export function getQueryParams(url: string) {
  const qparams: any = {};
  const parts = (url || '').split('?');
  let qpart;
  let i: any = 0;

  if (parts.length <= 1) {
    return qparams;
  }
  const qparts = parts[1].split('&');
  // eslint-disable-next-line
  for (i in qparts) {
    qpart = qparts[i].split('=');
    qparams[decodeURIComponent(qpart[0])] = decodeURIComponent(qpart[1] || '');
  }

  return qparams;
}

/**
 * Notify the host (browser parent iframe OR React Native WebView).
 * In RN WebView, only post via ReactNativeWebView — also calling parent.postMessage
 * would double-fire once the native bridge patches parent.postMessage.
 */
export function postToHost(message: Record<string, unknown>) {
  try {
    const rn = (window as any).ReactNativeWebView;
    if (rn && typeof rn.postMessage === 'function') {
      rn.postMessage(JSON.stringify(message));
      return;
    }
  } catch (e) {
    // ignore — fall through to parent postMessage for web iframes
  }
  try {
    window.parent.postMessage(message, '*');
  } catch (e) {
    // ignore
  }
}

/**
 * Per-order answer cache for v2 pagination. localStorage (not sessionStorage)
 * so answers survive iframe/WebView remounts when the host advances order=N.
 */
export function getOrderAnswerStorage(): Storage {
  try {
    return window.localStorage;
  } catch (e) {
    return window.sessionStorage;
  }
}
